export default {
  name: 'IEFA LatAm Forum',
  shortName: 'Buenos Aires',
  description:
    'The IEFA LatAm Forum held its first edition in 2022, and is an annual international conference focused on the opportunities that Latin America presents within today’s global economy.',
  thumbnail: '/images/events/buenosAires/thumbnail-buenosAires.jpg',
  link: 'https://www.latamforum.com/',
  header: {
    content:
      'The IEFA LatAm Forum held its first edition in 2022, and is an annual international conference focused on the opportunities that Latin America presents within today’s global economy.'
  },
  bullets: {
    bullet1: {
      number: '2nd',
      label: 'Edition'
    },
    bullet2: {
      number: '400+',
      label: 'In-Person Participants'
    },
    bullet3: {
      number: '30+',
      label: 'Speakers'
    },
    bullet4: {
      number: '20+',
      label: 'Represented Countries'
    }
  },
  about: {
    title: 'Our Purpose',
    content:
      'The private, by invitation only event was created as a platform to discuss Latin America’s increasingly important role in the global economy. As the world seeks a more sustainable and resilient future, the IEFA LatAm Forum identifies the Latin American organizations and institutions which are helping to realize this objective, both within the region and worldwide.'
  },
  next: {
    title: '2nd edition',
    content:
      'The 2024 edition will convene international thought leaders and decision makers to examine the various opportunities throughout the Americas which can enable the global transition. Held at the Four Seasons Hotel in Buenos Aires, Argentina, the conference will feature two days of keynote speeches, panel discussions, private luncheons, dinners and cocktail receptions, providing numerous occasions for participants to network and connect.',
    link: 'https://www.worldstrategicforum.com/'
  },
  gallery: {
    title: 'Photo gallery',
    edition11: {
      title: '11th edition — Investing in Trust',
      index: [
        {
          image: '/images/events/miami/gallery/12th-miami-001.jpg'
        }
      ]
    }
  }
}
